import { getCloudinaryUrl } from "@swiggy-private/js-utils";

export const ORDER_PAY_WAITER_SUCCESS_CONSTANTS = {
    TITLE: "Request sent to waiter",
    SUBTITLE: "The waiter will come to your table soon to collect the payment from you",
    IMAGE_ALT: "Request sent to waiter",
    ICON_WIDTH: 124,
    ICON_HEIGHT: 162,
    PRIMARY_BUTTON_TEXT: "Ok, that’s great!",
    IMAGE:
        getCloudinaryUrl(
            "portal/static-assets/images/digital-menu/all-theme-assets/chef_confirmation_final.png"
        ) || "",
};

export const ORDER_PAY_WAITER_FAILURE_CONSTANTS = {
    TITLE: "Unable to send your request at this moment",
    SUBTITLE: "Please retry or call the waiter directly ",
    IMAGE_ALT: "Request failed to send image",
    PRIMARY_BUTTON_TEXT: "Retry",
    IMAGE: getCloudinaryUrl("portal/static-assets/icons/digital-menu/error-filled.png") || "",
    ICON_WIDTH: 40,
    ICON_HEIGHT: 40,
};

export const STYLED_CONSTANTS = {
    MARGIN_BOTTOM: "45px",
    BUTTON_CONTAINER_PADDING_BOTTOM: "28px",
};
